const colors = {
    "GAINSBORO_1": "#f6f6f6",
    "GAINSBORO_3": "#e0e0e2",
    "GAINSBORO": "#e0e0e2",
    "GAINSBORO_2": "#ebebec",
    "GAINSBORO_4": "#bbbbbc",
    "GAINSBORO_5": "#959597",
    "GAINSBORO_6": "#707071",
    "GAINSBORO_7": "#4b4b4b",
    "GAINSBORO_8": "#252526",
    "GAINSBORO_9": "#000000",
    "MIDDLE_BLUE_GREEN_1": "#d9f2ee",
    "MIDDLE_BLUE_GREEN_3": "#81d2c7",
    "MIDDLE_BLUE_GREEN": "#81d2c7",
    "MIDDLE_BLUE_GREEN_2": "#ade2db",
    "MIDDLE_BLUE_GREEN_4": "#6cafa6",
    "MIDDLE_BLUE_GREEN_5": "#568c85",
    "MIDDLE_BLUE_GREEN_6": "#416964",
    "MIDDLE_BLUE_GREEN_7": "#2b4642",
    "MIDDLE_BLUE_GREEN_8": "#162321",
    "MIDDLE_BLUE_GREEN_9": "#000000",
    "CHARCOAL_1": "#c4c7cc",
    "CHARCOAL_3": "#3a4454",
    "CHARCOAL": "#3a4454",
    "CHARCOAL_2": "#7f8590",
    "CHARCOAL_4": "#303946",
    "CHARCOAL_5": "#272d38",
    "CHARCOAL_6": "#1d222a",
    "CHARCOAL_7": "#13171c",
    "CHARCOAL_8": "#0a0b0e",
    "CHARCOAL_9": "#000000",
    "DARK_ELECTRICS_BLUE_1": "#cbd2d8",
    "DARK_ELECTRICS_BLUE_3": "#53687e",
    "DARK_ELECTRICS_BLUE": "#53687e",
    "DARK_ELECTRICS_BLUE_2": "#8f9dab",
    "DARK_ELECTRICS_BLUE_4": "#455769",
    "DARK_ELECTRICS_BLUE_5": "#374554",
    "DARK_ELECTRICS_BLUE_6": "#2a343f",
    "DARK_ELECTRICS_BLUE_7": "#1c232a",
    "DARK_ELECTRICS_BLUE_8": "#0e1115",
    "DARK_ELECTRICS_BLUE_9": "#000000",
    "LIGHT_PERIWINKLE_1": "#e9eaf1",
    "LIGHT_PERIWINKLE_3": "#b5bad0",
    "LIGHT_PERIWINKLE": "#b5bad0",
    "LIGHT_PERIWINKLE_2": "#cfd2e0",
    "LIGHT_PERIWINKLE_4": "#979bad",
    "LIGHT_PERIWINKLE_5": "#797c8b",
    "LIGHT_PERIWINKLE_6": "#5b5d68",
    "LIGHT_PERIWINKLE_7": "#3c3e45",
    "LIGHT_PERIWINKLE_8": "#1e1f23",
    "LIGHT_PERIWINKLE_9": "#000000",
    "MIDNIGHT_BLUE_1": "#babad4",
    "MIDNIGHT_BLUE_3": "#191970",
    "MIDNIGHT_BLUE": "#191970",
    "MIDNIGHT_BLUE_2": "#6a6aa2",
    "MIDNIGHT_BLUE_4": "#15155d",
    "MIDNIGHT_BLUE_5": "#11114b",
    "MIDNIGHT_BLUE_6": "#0d0d38",
    "MIDNIGHT_BLUE_7": "#080825",
    "MIDNIGHT_BLUE_8": "#040413",
    "MIDNIGHT_BLUE_9": "#000000",
    "DELETE_RED_1": "#ffc5bf",
    "DELETE_RED_3": "#FF3C28",
    "DELETE_RED": "#FF3C28",
    "DELETE_RED_2": "#ff8073",
    "DELETE_RED_4": "#d53221",
    "DELETE_RED_5": "#aa281b",
    "DELETE_RED_6": "#801e14",
    "DELETE_RED_7": "#55140d",
    "DELETE_RED_8": "#2b0a07",
    "DELETE_RED_9": "#000000"
}

export default colors

export const contextColors = {
    SKOBELOFF: "#297373",
    YELLOW_CRAYOLA: "#F9E784",
    COPPER_CRAYOLA: "#E58F65",
    INDIAN_RED: "#D05353",
    CADET_BLUE: "#58A4B0",
    SALMON: "#F38375",
    OLD_GOLD: "#BFAB25",
    MAROON_X_11: "#B81365",
    WISTERIA: "#BEA7E5",
    HONEYDEW: "#F1FAEE"
} as { [key: string]: string }

export const contextColorsByHex = {} as { [key: string]: string }

Object.keys(contextColors).forEach((colorName) => {
    contextColorsByHex[contextColors[colorName]] = colorName
})



